import { useTranslation } from "react-i18next"

import "./ReplayControls.css"

/* The round stepper: previous, play/pause, next, and a slider across every playable snapshot.
   It takes the round clock's seat in the game's top bar while the view is in review mode — the
   clock counts down a round that will never come, and this is what a finished game has instead
   (owner's ask, 2026-09-07).

   **Nothing in it may change width**, because the slider is a control somebody drags and clicks
   round after round, and a control that moves under the cursor between rounds is the thing that
   made stepping through a game annoying (owner, 2026-09-08). The top bar holds the group still
   from the outside (`#top-bar` is a three-column grid). The two things that moved it from the
   inside are here: the round label grows a character at round 10, and the play button is as wide
   as its word — "Reproducir" is half again as wide as "Pausa". So each renders its widest state
   underneath, hidden but taking the space (`replay-ghost`), and the visible text sits on top of
   it. Measured rather than guessed, and in whatever language: the ghost is the same string the
   label will read at the last round, and the other word of the same button. */
const ReplayControls = ({ playable, tick, total, shownIndex, onTick, playing, onTogglePlay }) => {
  const { t } = useTranslation()
  if (!playable.length) return null
  return (
    <div className="replay-controls" role="group" aria-label={t("replay.round", { tick, total })}>
      <span className="replay-round">
        <span className="replay-ghost">{t("replay.round", { tick: total, total })}</span>
        <span>{t("replay.round", { tick, total })}</span>
      </span>
      <button
        type="button"
        onClick={() => onTick(playable[Math.max(0, shownIndex - 1)].tick)}
        disabled={shownIndex <= 0}
        aria-label={t("replay.previous")}
      >
        ‹
      </button>
      <button type="button" className="replay-play" onClick={onTogglePlay}>
        {/* `visibility: hidden` rather than a width guess: it keeps the box and drops the ghost
            from the accessibility tree, so the button still reads as the one word it means. */}
        <span className="replay-ghost">{playing ? t("replay.play") : t("replay.pause")}</span>
        <span>{playing ? t("replay.pause") : t("replay.play")}</span>
      </button>
      <button
        type="button"
        onClick={() => onTick(playable[Math.min(playable.length - 1, shownIndex + 1)].tick)}
        disabled={shownIndex >= playable.length - 1}
        aria-label={t("replay.next")}
      >
        ›
      </button>
      <input
        type="range"
        min={0}
        max={playable.length - 1}
        value={Math.max(0, shownIndex)}
        onChange={(event) => onTick(playable[Number(event.target.value)].tick)}
        aria-label={t("replay.round", { tick, total })}
      />
    </div>
  )
}

export default ReplayControls
